import { useEffect, useState } from "react"
import { Button, Modal } from 'react-bootstrap'
import toast from "react-hot-toast"
import { useNavigate } from "react-router-dom"

import LoadingTextSwap from "../../components/LoadingTextSwap"
import { useAcceptInviteMutation } from "../../app/clubsApiSlice"
import { useModal } from "../../context/ModalContext"

const JoinClubButton = ({ clubName, clubId, inviteId, disableButtons, setDisableButtons }) => {
  const Navigate = useNavigate()
  const { openModal } = useModal()
  const [acceptInvite, { isLoading }] = useAcceptInviteMutation()

  useEffect(() => {
    if (isLoading) {
      setDisableButtons(true)
    } else {
      setDisableButtons(false)
    }
  }, [isLoading, setDisableButtons])

  const [show, setShow] = useState(false)

  const handleShow = () => setShow(true)
  const handleClose = () => {
    setShow(false)
  }

  const handleConfirm = async () => {
    try {
      await acceptInvite({ clubId, clubName, inviteId }).unwrap()
      openModal({
        title: (
          <span>Success!</span>
        ),
        body: (
          <span>You are now a member of the club <strong className="text-dark">"{clubId}"</strong></span>
        )
      })
      handleClose()
      Navigate(`/user/clubs/view-club/${clubId}`)

    } catch (error) {
      console.log(error.data.message)
      if (error.data.message === "User is already a member of the club") {
        toast.error("You are already a member of this club")
      } else toast.error("Error accepting invite")

      handleClose()
    }
  }

  return (
    <>
      <Button
        variant="dark"
        className="rounded-3 px-3 w-50"
        onClick={handleShow}
        disabled={disableButtons}
      >
        Accept
      </Button>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header className="border-0 p-0 mb-2">
          <Modal.Title className="fs-5 fw-bold">Accept invite to {clubId}?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 text-muted fs-7 mb-3">You can only be a member of one club.</Modal.Body>
        <Modal.Footer className="p-0 border-0">
          <Button disabled={isLoading} className="rounded-3 m-0 fs-7 me-2" variant="dark" style={{ width: "100px" }} onClick={handleConfirm}>
            <LoadingTextSwap isLoading={isLoading}>
              Accept
            </LoadingTextSwap>
          </Button>
          <Button className="shadow-btn rounded-3 border-1 m-0 border-light fs-7" variant="white" style={{ width: "100px" }} onClick={handleClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default JoinClubButton